const IconBoxBlockIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path fill="#333" d="M0 18h24v2H0zM0 22h24v2H0z" />
    <path fill="#ffd400" d="M2 2h20v10H2z" />
    <path d="M22 2v10H2V2h20m2-2H0v14h24V0z" fill="#333" />
    <path
      fill="#333"
      d="M12 8.646l1.545.854-.295-1.809L14.5 6.41l-1.727-.264L12 4.5l-.773 1.646L9.5 6.41l1.25 1.281-.295 1.809L12 8.646z"
    />
  </svg>
);

export default IconBoxBlockIcon;
